import { Tooltip, Typography } from 'front-commons/ds';
import { OptionsProps } from 'front-commons/ds/components/Options/interfaces';
import type { RoleTypes, StatusTypes } from 'stores/pos/interfaces';

export const statusOptions = [
	{
		value: 'READY',
		label: 'Aprovado',
	},
	{
		value: 'BLOCKED',
		label: 'Bloqueado',
	},
	{
		value: 'REJECTED',
		label: 'Reprovado',
	},
	{
		value: 'ALL',
		label: 'Todos',
	},
];


export const roleParser = (role: RoleTypes) => {
	switch (role) {
		case 'BUYER': {
			return 'Comprador';
		}
		case 'SUPERVISOR': {
			return 'Supervisor';
		}
		case 'CONSULTANT': {
			return 'Consultor';
		}
		default: {
			return 'Administrador';
		}
	}
};

export const statusParser = (status: StatusTypes) => {
	switch (status) {
		case 'REJECTED': {
			return <Typography>Reprovado</Typography>;
		}
		case 'PENDING': {
			return (
				<Tooltip content="Aguardando aprovação do administrador.">
					<Typography>Aprovação pendente</Typography>
				</Tooltip>
			);
		}
		case 'BLOCKED': {
			return <Typography>Bloqueado</Typography>;
		}
		default: {
			return <Typography>Aprovado</Typography>;
		}
	}
};

export const getOptionsItemsByStatus = (
	status: StatusTypes,
	callback: (status: StatusTypes, userId: string[]) => void,
	id: string,
	role: RoleTypes,
): OptionsProps['items'] => {
	switch (status) {
		case 'REJECTED': {
			return [
				{
					label: 'Aprovar',
					onClick() {
						callback('READY', [id]);
					},
				},
			];
		}
		case 'PENDING': {
			return [
				{
					label: 'Aprovar',
					onClick() {
						callback('READY', [id]);
					},
				},
				{
					label: 'Reprovar',
					onClick() {
						callback('REJECTED', [id]);
					},
				},
			];
		}
		case 'BLOCKED': {
			return [
				{
					label: 'Desbloquear',
					onClick() {
						callback('READY', [id]);
					},
				},
			];
		}
		default: {
			if (role !== 'SUPERVISOR' && role !== 'CONSULTANT') {
				return [
					{
						label: 'Bloquear',
						onClick() {
							callback('BLOCKED', [id]);
						},
					},
				];
			}
			return [];
		}
	}
};
